var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMarketplace = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "E-Commerce-Basket-Monitor--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "E Commerce Basket Monitor Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M24 3.12a2 2 0 0 0 -2 -2H2a2 2 0 0 0 -2 2v14a2 2 0 0 0 2 2h7.53a0.23 0.23 0 0 1 0.2 0.11 0.22 0.22 0 0 1 0 0.22 8.12 8.12 0 0 1 -0.83 1.8 0.23 0.23 0 0 1 -0.21 0.13H7a0.75 0.75 0 0 0 -0.75 0.74 0.76 0.76 0 0 0 0.75 0.76h10a0.76 0.76 0 0 0 0.75 -0.76 0.75 0.75 0 0 0 -0.75 -0.74h-1.74a0.26 0.26 0 0 1 -0.22 -0.13 8 8 0 0 1 -0.82 -1.8 0.24 0.24 0 0 1 0 -0.22 0.23 0.23 0 0 1 0.2 -0.11H22a2 2 0 0 0 2 -2l0 -14Zm-21 0h18a1 1 0 0 1 1 1v9a1 1 0 0 1 -1 1H3a1 1 0 0 1 -1 -1v-9a1 1 0 0 1 1 -1Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5 7.62h-0.76a0.25 0.25 0 0 1 -0.22 -0.13L14.4 5.27a0.74 0.74 0 0 0 -1 -0.33 0.75 0.75 0 0 0 -0.34 1l0.67 1.32a0.31 0.31 0 0 1 0 0.25 0.27 0.27 0 0 1 -0.22 0.11h-3a0.27 0.27 0 0 1 -0.22 -0.11 0.28 0.28 0 0 1 0 -0.25l0.67 -1.32a0.75 0.75 0 0 0 -0.34 -1 0.74 0.74 0 0 0 -1 0.33L8.48 7.49a0.25 0.25 0 0 1 -0.22 0.13H7.5a0.52 0.52 0 0 0 -0.5 0.62l0.86 3.49a1.16 1.16 0 0 0 1.2 0.89h5.85a1.17 1.17 0 0 0 1.21 -0.89L17 8.24a0.46 0.46 0 0 0 -0.09 -0.42 0.5 0.5 0 0 0 -0.41 -0.2Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMarketplace);
export default ForwardRef;